module.exports = __webpack_public_path__ + "common/tp-featured9-0502f2128447807d06c2989002ba2f18.svg";